import React, { Suspense, useEffect, useContext } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HashRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import Spinner from "./views/Spinner/Spinner";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import setupFetchInterceptor from './SetupFetchInterceptor'; 

const root = ReactDOM.createRoot(document.getElementById("root"));

const AppWithInterceptor = () => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    if (authContext) {
      setupFetchInterceptor(authContext.login, authContext.logout);
    }
  }, [authContext]);

  return <App />;
};

root.render(
  <React.StrictMode>
    <Suspense fallback={<Spinner />}>
      <HashRouter>
        <AuthProvider>
          <AppWithInterceptor />
        </AuthProvider>
      </HashRouter>
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();
